/**
 * Clientes y sectores de experiencia del estudio.
 *
 * `logo`: monocromo crema en `public/assets/clients/<slug>.webp` (recoloreado
 * para leer sobre el navy — ver `_logos.mjs`). Sin `logo` se muestra el nombre
 * en serif. Fuentes originales en `docs/clients-source/`.
 */

export const clientGroups = [
  {
    id: 'empresas',
    label: 'Empresas',
    clients: [
      { name: 'Trayecta', logo: '/assets/clients/trayecta.webp' },
      { name: 'Petrizzio', logo: '/assets/clients/petrizzio.webp' },
      { name: 'Servipet', logo: '/assets/clients/servipet.webp' },
      { name: 'Elevva', logo: '/assets/clients/elevva.webp' },
      { name: 'Containerland', logo: '/assets/clients/containerland.webp' },
      {
        name: 'Herencia de Campo',
        logo: '/assets/clients/herencia-de-campo.webp',
      },
      { name: 'Los Piures', logo: '/assets/clients/los-piures.webp' },
      { name: 'Grupo Crucero', logo: '/assets/clients/grupo-crucero.webp' },
      { name: 'Kano', logo: '/assets/clients/kano.webp' },
      { name: 'Bodytrainer', logo: '/assets/clients/bodytrainer.webp' },
      { name: 'Punta Ranco', logo: '/assets/clients/punta-ranco.webp' },
      { name: 'Gysling y Cía.', logo: '/assets/clients/gysling-cia.webp' },
      { name: 'BCI Seguros', logo: '/assets/clients/bci-seguros.webp' },
      { name: 'Bison Agents', logo: '/assets/clients/bison-agents.webp' },
      { name: 'Viña Caminomar', logo: '/assets/clients/vina-caminomar.webp' },
      {
        name: 'Transportes Berna',
        logo: '/assets/clients/transportes-berna.webp',
      },
    ],
  },
  {
    id: 'organizaciones',
    label: 'Fundaciones y corporaciones',
    clients: [
      {
        name: 'Corporación Japonesa de Beneficencia',
        logo: '/assets/clients/japonesa-beneficencia.webp',
      },
      {
        name: 'Corporación A-MAR Cultura',
        logo: '/assets/clients/amar-cultura.webp',
      },
      {
        name: 'Asociación Gremial de Queseros',
        logo: '/assets/clients/queseros.webp',
      },
    ],
  },
];

// Asuntos representativos y testimonios — pendientes de entrega del estudio.
// Cuando lleguen, /experiencia los renderiza automáticamente (hoy se ocultan
// si están vacíos).
export const representativeMatters = [];
export const testimonials = [];

// Sectores en los que el estudio tiene experiencia. `icon` → <SectorIcon id>.
export const sectors = [
  { id: 'transporte', label: 'Transporte' },
  { id: 'retail', label: 'Retail' },
  { id: 'inmobiliario', label: 'Inmobiliario' },
  { id: 'agroindustria', label: 'Agroindustria' },
  { id: 'sin-fines-de-lucro', label: 'Organizaciones sin fines de lucro' },
  { id: 'cultura', label: 'Cultura' },
  { id: 'empresas-familiares', label: 'Empresas familiares' },
  { id: 'startups', label: 'Startups y nuevos negocios' },
];
